import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Helper Core Assignments and Requests ")

import { IncrediCard, IncrediChartLine } from 'incredi-ui';
import { computed } from 'vue';
import IbxScopedCss from '@/components/IbxScopedCss/IbxScopedCss.vue';
import DashboardChartTitle from '@/views/dashboard/components/dashboard-chart-title.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'helper-need-rate-chart',
  props: {
    chartOptions: null
  },
  setup(__props: any) {

const props = __props as {
  chartOptions: InstanceType<typeof IncrediChartLine>['$props'];
}


const chartProps = computed(() => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { options, ...rest } = props.chartOptions;
  return rest;
});

const tooltip = [
  {
    description: 'Learn how the grid adapts to acceleration demands during active build sessions.',
  },
  {
    title: 'Requested Cores',
    description: 'Initiators demand for distribution.',
  },
  {
    title: 'Available Cores',
    description: 'Actual cores in your helpers pool that are potential to help.',
  },
  {
    title: 'Assigned Cores',
    description: ['Cores actively used for builds and utilized for build acceleration.', 'This curve reflects the practical allocation of computing resources.'],
  },
];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(IbxScopedCss, null, {
    default: _withCtx(() => [
      _createVNode(_unref(IncrediCard), { class: "relative h-full p-[16px] !shadow-none border border-Border/border_natural" }, {
        default: _withCtx(() => [
          _createVNode(DashboardChartTitle, {
            absolute: "",
            tooltip: tooltip
          }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }),
          _createVNode(_unref(IncrediChartLine), _mergeProps({
            options: {
          ...(__props.chartOptions.options || {}),
          dataZoom: [
            {
              type: 'inside',
              startValue: 0,
              endValue: 120,
              maxValueSpan: 120,
              labelFormatter(value, valueStr) {
                const parsed = JSON.parse(valueStr);
                return parsed.label;
              },
            },
            {
              type: 'slider',
              maxValueSpan: 120,
              brushSelect: false,
              labelFormatter(value, valueStr) {
                const parsed = JSON.parse(valueStr);
                return parsed.label;
              },
            },
          ],
        },
            height: "284px"
          }, _unref(chartProps)), null, 16, ["options"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})